module.exports = "https://dev.stanwinstonschool.com/species_poster_org.55b4fbcaba1201094cd67bd0bd605e49.jpg";